







































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// components
import SelectMediaFolderModal from "@/components/files/modals/SelectMediaFolderModal.vue";
import BehaviorDropdown from "@/components/posts/BehaviorDropdown.vue";
// service methods
import { getFolderContent } from "@/services/folders/folderService";
// types
import { BehaviorEnum } from "@/services/posts/types";
import i18n from "@/i18n";
import { FolderPostProperties, FolderSortTypes, FolderPostSettings } from "@/services/posts/postTypes/folder";
import { Folder } from "@/services/folders/types";
import { MediaType } from "@/services/files/types";
import { FILEENDPOINT } from "@/app.config";
import { ValidationModel } from "@/services/validation/types";

@Component({
    components: {
        SelectMediaFolderModal,
        BehaviorDropdown
    }
})
export default class FolderForm extends Vue {
    @Prop() private properties!: FolderPostProperties;
    @Prop() private channelHeight!: number;
    @Prop() private channelWidth!: number;
    @Prop() postSettings!: FolderPostSettings;

    containerSize = {
        width: 0,
        height: 0
    };

    mediaSize = {
        width: 0,
        height: 0,
        origWidth: 0,
        origHeight: 0
    };

    // local state
    localProperties = {
        path: "",
        name: "",
        behavior: "" as BehaviorEnum,
        sort: FolderSortTypes.alphanumeric as FolderSortTypes
    } as FolderPostProperties;

    behaviorTypes: any = Object.keys(BehaviorEnum)
        .map(key => ({ name: i18n.t(`posts.${key}`), id: key })).filter(x => x.id !== "adjust");

    sortTypes: any = Object.keys(FolderSortTypes)
        .map(key => ({ name: i18n.t(`posts.${key}`), id: key }));

    imageCount = 0;
    videoCount = 0;
    firstImageId = "";
    firstVideoId = "";

    validators = {
        behavior: {
            active: null
        } as unknown as ValidationModel,
        folder: {
            active: null
        } as unknown as ValidationModel,
        sorting: {
            active: null
        } as unknown as ValidationModel
    };

    @Watch("localProperties.behavior", { immediate: true }) localPropWatch() {
        this.calcLetterbox();
    }

    // lifecycle hooks
    mounted() {
        this.localProperties.behavior = "letterBox" as BehaviorEnum;
        if (this.properties && this.properties.path) {
            this.localProperties = this.properties;
            getFolderContent(this.localProperties.path).then(response => {
                this.imageCount = response.filter(x => x.type === MediaType.Image).length;
                this.videoCount = response.filter(x => x.type === MediaType.Video).length;

                if (this.imageCount > 0) {
                    const image = response
                        .find(x => x.type === MediaType.Image);

                    if (image) {
                        this.firstImageId = image.id;
                        this.$nextTick(() => {
                            this.loadMedia();
                        });
                    }
                } else if (this.videoCount > 0) {
                    const video = response.find(x => x.type === MediaType.Video);

                    if (video) {
                        this.firstVideoId = video.id;
                        this.$nextTick(() => {
                            this.loadMedia(true);
                        });
                    }
                }
            });
        } else {
            this.$emit("setDefaultValues", JSON.stringify(this.localProperties));
        }
    }

    loadMedia(video = false) {
        if (video) {
            const video = this.$refs.video as HTMLVideoElement;

            video.onloadeddata = () => {
                this.calcAspectRatio(this.channelWidth, this.channelHeight, 200, 200, video.videoWidth, video.videoHeight);
                this.calcLetterbox();
            };
            video.src = `${FILEENDPOINT}${this.firstVideoId}`;
            return;
        }
        const image = new Image();
        image.onload = () => {
            this.calcAspectRatio(this.channelWidth, this.channelHeight, 200, 200, image.width, image.height);
            this.calcLetterbox();
        };
        image.src = this.imageUrl;
    }

    calcAspectRatio(srcWidth: number, srcHeight: number, maxWidth: number, maxHeight: number, mediaWidth: number, mediaHeight: number) {
        var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        const calc = { width: srcWidth * ratio, height: srcHeight * ratio, ratio };

        this.containerSize.width = calc.width;
        this.containerSize.height = calc.height;
        this.mediaSize.width = mediaWidth * calc.ratio;
        this.mediaSize.height = mediaHeight * calc.ratio;
        this.mediaSize.origWidth = mediaWidth * calc.ratio;
        this.mediaSize.origHeight = mediaHeight * calc.ratio;
    }

    calcLetterbox() {
        if (this.localProperties.behavior !== undefined) {
            if (this.localProperties.behavior === BehaviorEnum.letterBox) {
                if (this.mediaSize.origWidth > this.containerSize.width || this.mediaSize.origHeight > this.containerSize.height) {
                    var ratio = Math.min(this.containerSize.width / this.mediaSize.origWidth, this.containerSize.height / this.mediaSize.origHeight);
                    this.mediaSize.width = this.mediaSize.origWidth * ratio;
                    this.mediaSize.height = this.mediaSize.origHeight * ratio;
                }
            } else if (this.localProperties.behavior === BehaviorEnum.crop) {
                if (this.mediaSize.origWidth > this.containerSize.width && this.mediaSize.origHeight > this.containerSize.height) {
                    this.mediaSize.width = this.containerSize.width;
                    this.mediaSize.height = this.containerSize.height;
                }
            } else {
                this.mediaSize.width = this.mediaSize.origWidth;
                this.mediaSize.height = this.mediaSize.origHeight;
            }
        }
    }

    // computed
    get folderContent(): string {
        let content = "(";

        content += `${this.imageCount} image`;
        if (this.imageCount === 0 || this.imageCount > 1) content += "s";

        content += `, ${this.videoCount} video`;
        if (this.videoCount === 0 || this.videoCount > 1) content += "s";
        content += ")";

        return content;
    }

    get imageUrl(): string {
        return `${FILEENDPOINT}${this.firstImageId}`;
    }

    get behaviorValid(): boolean {
        return this.localProperties.behavior.length > 0;
    }

    get folderValid(): boolean {
        return this.localProperties.path.length > 0;
    }

    get sortingValid(): boolean {
        return this.localProperties.sort.length > 0;
    }

    // methods
    openModal(preselect: boolean) {
        const folderId = preselect ? this.localProperties.path : "";
        (this.$refs.selectMediaFolderModal as any).open(folderId);
    }

    folderSelected(folder: Folder) {
        getFolderContent(folder.id).then(response => {
            this.imageCount = response.filter(x => x.type === MediaType.Image).length;
            this.videoCount = response.filter(x => x.type === MediaType.Video).length;

            this.localProperties.path = folder.id;
            this.localProperties.name = folder.name;
            this.setItemName();

            if (this.imageCount > 0) {
                const image = response
                    .find(x => x.type === MediaType.Image);

                if (image) {
                    this.firstImageId = image.id;
                    this.$nextTick(() => {
                        this.loadMedia();
                    });
                }
            } else if (this.videoCount > 0) {
                const video = response.find(x => x.type === MediaType.Video);

                if (video) {
                    this.firstVideoId = video.id;
                    this.$nextTick(() => {
                        this.loadMedia(true);
                    });
                }
            }
        });
    }

    removeFolder() {
        this.localProperties.name = "";
        this.localProperties.path = "";
        this.imageCount = 0;
        this.videoCount = 0;
        this.firstImageId = "";
        this.firstVideoId = "";
    }

    // events
    validateData() {
        this.validators.behavior.active = true;
        this.validators.folder.active = true;
        this.validators.sorting.active = true;
        return this.behaviorValid && this.folderValid && this.sortingValid;
    }

    emitData() {
        this.$emit("propertiesUpdated", this.localProperties);
    }

    setItemName() {
        var name = this.localProperties.caption || this.localProperties.name;
        this.$emit("itemNameUpdated", name);
    }
}
